module.exports = __webpack_public_path__ + "img/Syngenta logo.5c82ef96.png";